<template>
    <div>
        <v-dialog v-model="estadoComp" persistent max-width="600">
            <v-card>
                <v-card-title class="modal_title py-5 mb-2">
                    <v-row class="d-flex justify-end">
                        <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon
                                dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-col class="text-center ma-0" cols="12">
                        <template><!--  RESPUESTA PREGUNTA DESARROLLO -->
                            <v-row>
                                <v-col cols="12">
                                    Estudiante: {{ alumno.ape1_persona }} {{ alumno.ape2_persona }} {{ alumno.nombre_persona }}
                                </v-col>
                                <!-- id respuesta criterio docente  segun respuesta del alumno -->
                                <v-col cols="8">
                                    <v-select label="Calificar respuesta:" v-model="calificar.id_calificacion"
                                        :items="listCalificacion" item-value="id" item-text="calificacion">
                                    </v-select>
                                </v-col>
                                <v-col cols>
                                    <v-btn class="btn_block_style2" small @click="SaveItem()">Guardar</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                        <!--  END RESPUESTA PREGUNTA DESARROLLO -->
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';

export default {
    name: 'CalificacionManual',
    components: {},
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },
    data: () => ({
        rutaservidor: API_URL,
        paramComponente: { "id_modulo": 8, 'id_submodulo': 94 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,
        evento: null,
        inhabilitar: false,
        confirm: {
            id: 0,
            title: "",
            active: false,
        },
        //// CONSULTA PRINCIPAL
        // evento: 'agregar',
        data: [],
        calificar: {},
        preguntaEval: [],
        evaluacion: {},
        alumno: {},
        listCalificacion: [],
    }),
    //computadas
    computed: {
        ...mapGetters('login', ['componenteEvento'])
    },
    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        estadoComp() {
            if (this.estadoComp) {
                this.LoadMain()
            } else {
                this.LimpiarForm()
            }
        },
    },
    /*
    mounted() {
        this.LoadMain()
    }, */
    created() {
        this.LoadMain()
        this.actualizarParamentro()
    },
    methods: {
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        LoadMain() {
            this.calificar.id = this.parametros.items.id
            this.calificar.id_ano_lectivo = this.parametros.items.id_ano_lectivo
            this.calificar.id_colegio = this.parametros.items.id_colegio
            this.calificar.id_evaluacion = this.parametros.items.id_evaluacion
            this.calificar.id_alumno = this.parametros.items.id_alumno
            this.calificar.tipo_calificacion = this.parametros.items.tipo_calificacion
            // this.setEnviarMens({tipo:"W", mensaje: `Load Main (pregunta)`, tiempo:null})                
            console.log(`LoadMain() (calificacionMAnual.vue), estado Comp : ${this.estadoComp}, Evento: ${this.evento} `)
            this.evento = this.parametros.evento
            this.GetAlumnoEvaluacion(this.parametros.items.id_evaluacion, this.parametros.items.id_alumno)
        },

        async GetAlumnoEvaluacion(idEvaluacion, idAlumno) {

            try {
                let response = await axios.get(`/evaluacion/alumnos/evaluar/alumno/${idAlumno}/evaluacion/${idEvaluacion}`,)
                let data = response.data
                // console.log(this.data)
                if (data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                    this.preguntaEval = []
                } else {

                    this.evaluacion = data.evaluacion
                    this.alumno = data.alumno

                    if (this.evento == "qualify" || this.evento == "qualifyAlumno") {
                        this.GetEscalaEvaluativa()
                    }

                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         ______________________________________________________
        |          MÉTODO OBTENER ESCALA EVALUATIVA          */    
        async GetEscalaEvaluativa() {
            try {
                let params = {
                    id_colegio: this.evaluacion.id_colegio, id_ano_lectivo: this.evaluacion.id_ano_lectivo,
                    id_nivel: this.evaluacion.id_nivel, id_grado: this.evaluacion.id_grado,
                    calificar: true,
                }
                let response = await axios.post(`/evaluacion/programacion/escalaEvaluativaGrado/`, { filter: params })

                if (response.data.escalaEvaluacion.length == 0) {
                    this.setEnviarMens({ tipo: "E", mensaje: `No se configuro la escala evaluativa para el grado`, tiempo: 8000 })
                }

                console.log('response', response);

                this.listCalificacion = response.data.notaEvaluacion

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        async SaveItem() {

            if (this.calificar.id_calificacion == '' || this.calificar.id_calificacion == -1) {
                this.setEnviarMens({ tipo: "W", mensaje: "Debe de ingresar una calificación para la evalaución", tiempo: null })
                return false
            }
            console.log(`SaveItem`)
            let params = { datos: this.calificar }
            let res = await axios.post("/evaluacion/alumnosEvaluacion/calificarManual/", params)

            console.log("response Data:", res.data)

            if (res.data) {
                this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: null })
            }
        },

        Cancelar() {
            this.clear_confirm();
        },

        clear_confirm() {
            this.confirm.id = 0;
            this.confirm.title = "";
            this.confirm.active = false;
        },

        LimpiarForm() {

            this.calificar = {
                id: "",
                id_ano_lectivo: "",
                id_colegio: "",
                id_evaluacion: "",
                id_alumno: "",
                tipo_calificacion: "",
                id_calificacion: "",
                id_usuario: this.datoLogin.id
            }
        },
    },

}
</script>

<style scoped>
.texto_white {
    font-size: 14px;
    font-weight: bold;
    color: #fff !important;
}

.texto {
    font-size: 22px !important;
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for <2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}

.alertKW {
    border-style: solid;
    border-width: 0, 0, 0, 4px;

    background-color: #fff;
    border: 0px;
    border-left: 8px solid #1565c0;
    box-shadow: 1px 2px 4px 0px #888888;

    font-size: 16px;
    margin-bottom: 16px;
    padding: 8px;
    border-radius: 5px;
}
</style>
